import { useCallback, useRef } from 'react'
import { useDataChange, useDataValue } from 'Simple/Data.js'
import { equals } from 'Data/aggregate.js'
import mutation from './mutation-update-filters.graphql.js'
import { useMutation } from 'Data/Api'
import { useQueueAsync } from 'Logic/useQueueAsync.js'
import debounce from 'lodash/debounce.js'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let [, executeMutation] = useMutation(mutation)
  let { id: tab_id } = data

  let location_id = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'current_location._id',
  })

  let previous = useRef(data)

  let change = useDataChange({
    context: 'global',
    viewPath: props.viewPath,
  })

  return useCallback(debounce(useQueueAsync(onChange), 250), [])

  async function onChange(next, ...args) {
    if (!next) return

    if (
      !equals(
        previous.current.selected.filters?.filterData?.locations,
        next.selected.filters?.filterData?.locations
      )
    ) {
      //save the location filter presets

      try {
        await executeMutation({
          location_id,
          data: {
            filters: {
              filterData: {
                locations: next.selected.filters?.filterData?.locations,
              },
            },
          },
        })
      } catch (_) {}
    }

    previous.current = next

    change(inext => {
      if (tab_id !== inext.tab_id) return

      inext.tabs = inext.tabs.map(item => (item.id === tab_id ? next : item))
    })
  }
}
